import { useEffect, useState } from "react";

export default function TopBar({ activePage, onNavigate }) {
  const isTrader = activePage === "trader";
  const isReports = activePage === "reports";
  const isIde = activePage === "ide";

  const [feed, setFeed] = useState({
    feed_status: "UNKNOWN",
    feed_provider: "--",
    last_update: null,
  });

  useEffect(() => {
    let mounted = true;

    const loadFeed = async () => {
      try {
        const res = await fetch("/api/health", { credentials: "include" });
        if (!res.ok) throw new Error(`Feed status failed: ${res.status}`);
        const data = await res.json();
        if (!mounted) return;
        setFeed({
          feed_status: data.feed_status || "UNKNOWN",
          feed_provider: data.feed_provider || "--",
          last_update: data.last_update || null,
        });
      } catch {
        if (!mounted) return;
        setFeed({
          feed_status: "OFFLINE",
          feed_provider: "--",
          last_update: null,
        });
      }
    };

    loadFeed();
    const id = setInterval(loadFeed, 10000);

    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  const status = String(feed.feed_status || "").toUpperCase();
  const tone =
    status === "LIVE"
      ? "border-emerald-500/30 bg-emerald-500/15 text-emerald-300"
      : status === "POLL" || status === "FALLBACK"
      ? "border-amber-500/30 bg-amber-500/15 text-amber-300"
      : "border-red-500/30 bg-red-500/15 text-red-300";

  return (
    <div className="flex items-center justify-between px-6 py-3 border-b border-zinc-800 bg-zinc-950">
      <div className="flex items-center gap-4">
        <div className="text-lg font-semibold tracking-wide text-zinc-100">LEVELS</div>

        <div className={`text-xs px-2 py-1 rounded border ${tone}`}>
          {status || "UNKNOWN"} · {feed.feed_provider || "--"}
        </div>
      </div>

      <div className="hidden md:block text-xs text-zinc-500">
        {feed.last_update ? `Last update ${feed.last_update}` : "Feed monitor"}
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onNavigate("trader")}
          className={`px-3 py-1.5 rounded text-sm border ${
            isTrader
              ? "border-sky-500/30 bg-sky-500/15 text-sky-300"
              : "border-zinc-800 bg-zinc-900 text-zinc-400"
          }`}
        >
          Trader
        </button>

        <button
          onClick={() => onNavigate("ide")}
          className={`px-3 py-1.5 rounded text-sm border ${
            isIde
              ? "border-purple-500/30 bg-purple-500/15 text-purple-300"
              : "border-zinc-800 bg-zinc-900 text-zinc-400"
          }`}
        >
          IDE
        </button>

        <button
          onClick={() => onNavigate("reports")}
          className={`px-3 py-1.5 rounded text-sm border ${
            isReports
              ? "border-sky-500/30 bg-sky-500/15 text-sky-300"
              : "border-zinc-800 bg-zinc-900 text-zinc-400"
          }`}
        >
          Reports
        </button>
      </div>
    </div>
  );
}
